var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "landing-head",
      class: `landing-head_align_${_vm.logoAlignment}`,
    },
    [
      _c("inline-svg", {
        staticClass: "landing-head__logo",
        class: `landing-head__logo_color_${_vm.logoColor}`,
        attrs: { src: require("@/assets/logos/logo-inline-to-be-colored.svg") },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }